import React, { useContext, useEffect, useState } from 'react'
import '../v2/PhoneNumberForm/index.scss'
import CountryCode from '@App/kit/fields/PhoneNumberForm/CountryCode'
import AreaCode from '@App/kit/fields/PhoneNumberForm/AreaCode'
import LineNumber from '@App/kit/fields/PhoneNumberForm/LineNumber'
import { useFormContext } from 'react-hook-form'
import { isPhoneCodeUS } from '@App/common/utils'
import { markFieldAsRequired, PhoneNumberFormProps } from '@App/forms/common/phone-number-form'
import { StoresContext } from '@App/contexts'
import { setRequiredIfTrue } from '@App/helpers/validate'
import { MIN_LENGTH_MESSAGE } from '@Const/error-messages'

interface PhoneNumberFormPropsForComponent {
    phoneNumberFormProps: PhoneNumberFormProps
    optional?: boolean
}

const PhoneNumberForm = (props: PhoneNumberFormPropsForComponent) => {
    const { libStore } = useContext(StoresContext)
    const { phoneNumberFormProps, optional } = props
    const [phoneNumberFormFields, setPhoneNumberFormFields] = useState<PhoneNumberFormProps>(phoneNumberFormProps)
    const [numberIsOptional, setNumberIsOptional] = useState<boolean>(!!optional)

    const { watch } = useFormContext()

    const countryValue = watch(phoneNumberFormFields.phoneCountryCode.name)

    useEffect(() => {
        if (phoneNumberFormFields.phoneAreaCode.registerOptions) {
            if (isPhoneCodeUS(countryValue)) {
                phoneNumberFormFields.phoneAreaCode.registerOptions = {
                    ...phoneNumberFormFields.phoneAreaCode.registerOptions,
                    minLength: {
                        value: 3,
                        message: `${MIN_LENGTH_MESSAGE} 3`,
                    },
                }
            }
            phoneNumberFormFields.phoneAreaCode.registerOptions = setRequiredIfTrue(
                isPhoneCodeUS(countryValue),
                phoneNumberFormFields.phoneAreaCode.registerOptions
            )
        }
        if (phoneNumberFormFields.phoneNumber.registerOptions) {
            if (isPhoneCodeUS(countryValue)) {
                phoneNumberFormFields.phoneNumber.registerOptions = {
                    ...phoneNumberFormFields.phoneNumber.registerOptions,
                    minLength: {
                        value: 7,
                        message: `${MIN_LENGTH_MESSAGE} 7`,
                    },
                }
            }
        }

        setPhoneNumberFormFields({ ...phoneNumberFormFields })
    }, [countryValue])

    if (optional) {
        const areaCodeValue = watch(phoneNumberFormFields.phoneAreaCode.name)
        const lineNumberValue = watch(phoneNumberFormFields.phoneNumber.name)

        useEffect(() => {
            if (countryValue || areaCodeValue || lineNumberValue) {
                setNumberIsOptional(false)
            } else {
                setNumberIsOptional(true)
            }
        }, [countryValue, areaCodeValue, lineNumberValue])

        useEffect(() => {
            const formFields = markFieldAsRequired(phoneNumberFormFields, numberIsOptional)
            setPhoneNumberFormFields({ ...formFields })
        }, [numberIsOptional])
    }

    phoneNumberFormFields.phoneCountryCode.options = libStore.phoneCountryCodes

    return (
        <div className="phone-number-form-component">
            <label className="small main-phone-label">Phone Number</label>
            <div className="phone-inputs-block">
                <CountryCode {...phoneNumberFormFields.phoneCountryCode} />
                <AreaCode {...phoneNumberFormFields.phoneAreaCode} />
                <LineNumber {...phoneNumberFormFields.phoneNumber} />
            </div>
        </div>
    )
}

export default PhoneNumberForm
